<template>
  <v-alert
      v-if="messages.length > 0"
      :color="color"
      dense
      :outlined="outlined"
      :style="style"
      :type="type"
      :icon="icon ? false : undefined"
  >
    <template v-if="icon" #prepend>
      <v-icon
          :color="iconColor"
          :size="iconSize"
          class="mr-4"
      >
        {{ icon }}
      </v-icon>
    </template>

    <span v-if="title">{{ title }}: </span>
    <span v-html="message" />
  </v-alert>
</template>

<script>
export default {
  name: 'AlertMessage',
  props: {
    color: String,
    messages: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      required: true,
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    borderColor: String,
    backgroundColor: String,
    textColor: String,
    icon: String,
    iconColor: String,
    iconSize: [String, Number],
  },
  computed: {
    message() {
      return this.messages
          ? this.messages.map((item) => item.message).join(' ')
          : '';
    },
    style() {
      const style = {
        border: '2px solid currentColor !important',
        marginBottom: '0',
      };

      if (this.borderColor) {
        style.border = `2px solid ${this.borderColor} !important`;
      }

      if (this.backgroundColor) {
        style.background = `${this.backgroundColor} !important`;
      }

      if (this.textColor) {
        style.color = `${this.textColor} !important`;
      }

      return style;
    },
  },
};
</script>
